export enum SectionLayoutType {
    Tabs = 'Tabs',
    Page = 'Page'
}

//Class implementation of the interface with sync rules at packages/specification/src/sync/v4/export/controls/ObjectPageLayout.ts

/**
 * Page Layout
 *
 * @isViewNode true
 */
export interface ObjectPageLayout {
    /**
     * Defines the layout of the sections.
     * - Page (default): In this mode, all the sections and subsections are added to the same page.
     * - Tabs: In this mode, the sections are represented as tabs under the header facet.
     */
    sectionLayout?: SectionLayoutType;
}
